require("../sass/style.scss");

require("../fonts/fontello/css/fontello.css");
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css';

import 'swiper/css/bundle';

require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");
require("./vendor/jquery.resize");
require("./vendor/limarquee");
require("./vendor/video.min");
require("./vendor/select2.full");


require("./custom/custom-select.es6");
require("./custom/header.es6");
require("./custom/footer.es6");
require("./custom/modal.es6");
require("./custom/cookie_banner.es6");
require("./custom/anchor.es6");
require("./custom/youtube-video.es6");
require("./vendor/hyphenopoly/Hyphenopoly_Loader");

Hyphenopoly.config({
    "paths": {
        "maindir": "/wp-content/themes/revocit-theme/src/js/vendor/hyphenopoly/",
        "patterndir": "/wp-content/themes/revocit-theme/src/js/vendor/hyphenopoly/patterns/"
    },
    "require": {
        "de": "Silbentrennungsalgorithmus",
        "en-us": "Supercalifragilisticexpialidocious",
        "la": "honorificabilitudinitas"
    },
    "setup": {
        "selectors": {
            ".hyphenopoly": {}
        }
    }
});


(function ($) {
    $(".resultate").length > 0 && require("./page_builder/resultate.es6");
    $(".aktuelles-and-themen").length > 0 && require("./page_builder/aktuelles_and_themen.es6");
    $(".logo-wall").length > 0 && require("./page_builder/logo_wall.es6");
    $(".instagram-feed").length > 0 && require("./page_builder/instagram_feed.es6");
    $(".big-cases-block").length > 0 && require("./page_builder/big_cases_block.es6");
    $(".image-slider").length > 0 && require("./page_builder/image_slider.es6");
    $(".image-slider-type-2").length > 0 && require("./page_builder/image_slider_type_2.es6");
    $(".image-slider-type-3").length > 0 && require("./page_builder/image_slider_type_3.es6");
    $(".image-slider-type-4").length > 0 && require("./page_builder/image_slider_type_4.es6");
    $(".image-slider-type-5").length > 0 && require("./page_builder/image_slider_type_5.es6");
    $(".hero-type-1").length > 0 && require("./page_builder/hero_type_1.es6");
    $(".employees").length > 0 && require("./page_builder/employees.es6");
    $(".promote-engagement").length > 0 && require("./page_builder/promote_engagement.es6");
    $(".history-date").length > 0 && require("./page_builder/history_date_slider.es6");
    $(".section-video-slider").length > 0 && require("./page_builder/video_slider.es6");
    $(".section-kompetenzen-accordion").length > 0 && require("./page_builder/kompetenzen_accordion.es6");
    $(".process-slider-section").length > 0 && require("./page_builder/process_slider.es6");
    $(".numbers-slider-section").length > 0 && require("./page_builder/numbers_slider.es6");
    $(".info-block").length > 0 && require("./page_builder/info_block.es6");
    $(".video-slider-type-2").length > 0 && require("./page_builder/video_slider_type_2.es6");
    $(".video-open-trigger, .youtube-open-trigger").length > 0 && require("./custom/video-modal.es6");
    $(".collapse-section").length > 0 && require("./page_builder/collapse.es6");
    $(".slider-corresponding-posts").length > 0 && require("./page_builder/slider_corresponding_posts.es6");
    $(".aktuelles-themen-posts").length > 0 && require("./page_builder/aktuelles_themen_posts.es6");
    $(".section-single-post-aktuelles").length > 0 && require("./custom/single_aktuelles.es6");
    $(".section-single-post-agenturglossar").length > 0 && require("./custom/single_agenturglossar.es6");
    $(".section-bewerbungsprozess-accordion").length > 0 && require("./page_builder/bewerbungsprozess_accordion.es6");
    $(".section-bewerbungsprozess-accordion-type-1").length > 0 && require("./page_builder/bewerbungsprozess_accordion_type_1.es6");
    $(".agenturglossar-overview").length > 0 && require("./page_builder/agenturglossar_overview.es6");
    $(".section_unsere_prinzipien").length > 0 && require("./page_builder/section_unsere_prinzipien.es6");
    $(".section-kompetenzen-animation").length > 0 && require("./page_builder/section_kompetenzen_animation.es6");
    $(".small-cases-block").length > 0 && require("./page_builder/small_cases_block.es6");
    $(".section-video-slider-type-3").length > 0 && require("./page_builder/video_slider_type_3.es6");
    $(".content-04-section").length > 0 && require("./page_builder/content_04.es6");
    $(".content-06-section").length > 0 && require("./page_builder/content_06.es6");
    $(".section-accordion-01").length > 0 && require("./page_builder/accordion_01.es6");
    $(".section-accordion-02").length > 0 && require("./page_builder/accordion_02.es6");
    $(".logo-strip").length > 0 && require("./page_builder/logo_strip.es6");
    $(".section-reviews").length > 0 && require("./page_builder/reviews.es6");
    $(".resultate-teaser-slider").length > 0 && require("./page_builder/resultate_teaser_slider.es6");
    $(".floating-anchor-bar").length > 0 && require("./page_builder/floating_anchor_bar.es6");

    if ($(".contact-form-section").length > 0) {
        require("./page_builder/section_kontakt_form.es6");
        require("./custom/custom-ninha-form-validation.es6");
    }

})(jQuery);